/* LOCAL CANDIDATE: Tile only; prevent Horizon native variant-in-flight queue entry. */
(() => {
  'use strict';
  if (location.pathname.replace(/\/$/,'') !== '/products/premium-tile-tub-refinishing-paint-kit') return;
  const pid='10300967223487', deal='e976c2f5-5bc7-4446-8f10-eabe8eef877a';
  const blockSelector='kaching-bundle[product-id="'+pid+'"] .kaching-bundles__block[data-deal-block-id="'+deal+'"],kaching-bundles-block[deal-block-id="'+deal+'"]';
  const buttonSelector='button[name="add"],button[id*="ProductSubmitButton"],button[id^="SectionAtcBtn"],button#yx_checkout,button#yx_paypal_checkout,button#yx_kl_checkout';
  const owned=new Map(),formIds=new WeakMap();
  const owner='tile-native-variant-settle';
  let generation=0,pending=false,requestSettled=false,checkTimer=null,checks=0,nextFormId=0;
  function block(){return document.querySelector(blockSelector);}
  function section(){return block()?.closest('.shopify-section') || document.querySelector('variant-picker[data-product-id="'+pid+'"]')?.closest('.shopify-section');}
  function status(state,reason){const b=block();if(b){b.dataset.tileVariantGateState=state;b.dataset.tileVariantGateReason=reason;}}
  function lockButtons(){
    const s=section();if(!s)return;
    for(const button of s.querySelectorAll(buttonSelector)){
      if(!(button instanceof HTMLButtonElement))continue;
      if(owned.has(button)){
        if(button.dataset.tileVariantGateOwner===owner&&!button.disabled)button.disabled=true;
        continue;
      }
      if(button.disabled)continue;
      owned.set(button,{disabled:button.disabled});
      button.dataset.tileVariantGateOwner=owner;button.disabled=true;
    }
  }
  function release(){
    pending=false;requestSettled=false;clearTimeout(checkTimer);checkTimer=null;
    for(const [button,prior]of owned){
      if(button.dataset.tileVariantGateOwner!==owner)continue;
      button.disabled=prior.disabled;delete button.dataset.tileVariantGateOwner;
    }
    owned.clear();status('released','latest-native-event-promise-and-current-form-settled');
  }
  function snapshot(){
    const b=block(),s=section();if(!b||!s)return {ready:false,key:'waiting-for-product-dom'};
    const selected=[...b.querySelectorAll('.kaching-bundles__bar')].filter(x=>x.querySelector('input[type="radio"]')?.checked);
    if(selected.length!==1||!selected[0].classList.contains('kaching-bundles__bar--selected'))return {ready:false,key:'waiting-for-selected-offer'};
    const add=s.querySelector('button[id*="ProductSubmitButton"]') || s.querySelector('button[name="add"]');
    const f=add?.form;
    if(!f?.isConnected||!f.matches('form[action*="/cart/add"]'))return {ready:false,key:'waiting-for-current-add-form'};
    const checkbox=s.querySelector('input[name="subscription_enabled"][data-selling-plan-id]');
    if(!checkbox)return {ready:false,key:'waiting-for-purchase-choice'};
    if(f.dataset.yxSubFormPatched!=='1')return {ready:false,key:'waiting-for-native-subscription-handler'};
    const data=new FormData(f),plans=data.getAll('selling_plan').map(String).filter(Boolean);
    const intended=String(checkbox.dataset.sellingPlanId||'');
    if(checkbox.checked&&(!intended||plans.length!==1||plans[0]!==intended))return {ready:false,key:'waiting-for-current-plan'};
    if(!checkbox.checked&&plans.length)return {ready:false,key:'waiting-for-one-time-form'};
    if(!formIds.has(f))formIds.set(f,++nextFormId);
    const variants=[...selected[0].querySelectorAll('select.kaching-bundles__bar-variant-select')].map(x=>[x.dataset.name,x.value]);
    const native=[...s.querySelectorAll('variant-picker[data-product-id="'+pid+'"] input[data-option-name]:checked')].map(x=>[x.dataset.optionName,x.value]);
    return {ready:true,key:JSON.stringify([formIds.get(f),selected[0].dataset.dealBarId,variants,native,data.getAll('id').map(String),checkbox.checked,plans])};
  }
  function retry(mine,reason){
    if(!pending||generation!==mine||!requestSettled)return;
    status('pending',reason);
    if(++checks<20){clearTimeout(checkTimer);checkTimer=setTimeout(()=>verify(mine),100);}
    else status('pending','readiness-unresolved-reselect-variant-to-retry');
  }
  function verify(mine){
    checkTimer=null;if(!pending||generation!==mine||!requestSettled)return;
    lockButtons();const first=snapshot();if(!first.ready){retry(mine,first.key);return;}
    requestAnimationFrame(()=>{
      if(!pending||generation!==mine||!requestSettled)return;
      const second=snapshot();if(!second.ready||second.key!==first.key){retry(mine,'waiting-for-current-dom-stability');return;}
      requestAnimationFrame(()=>{
        if(!pending||generation!==mine||!requestSettled)return;
        const third=snapshot();if(!third.ready||third.key!==second.key){retry(mine,'waiting-for-current-dom-stability');return;}
        release();
      });
    });
  }
  window.addEventListener('shopify:product:select',event=>{
    const source=event.target;
    if(!(source instanceof Element)||!source.matches('variant-picker[data-product-id="'+pid+'"]')||source.closest('product-card'))return;
    if(String(event.product?.id||'').split('/').pop()!==pid||source.closest('.shopify-section')!==section())return;
    const mine=++generation;pending=true;requestSettled=false;checks=0;clearTimeout(checkTimer);
    lockButtons();status('pending','native-variant-request-in-flight');
    if(!event.promise||typeof event.promise.then!=='function'){status('pending','missing-native-settle-promise');return;}
    event.promise.then(()=>{
      if(!pending||generation!==mine)return;
      requestSettled=true;
      // The theme's own await-continuation runs after the same public promise.
      // A task boundary and two finite frames let its finally clear the native queue flag.
      checkTimer=setTimeout(()=>verify(mine),0);
    },()=>{
      if(generation===mine)status('pending','native-variant-request-failed-reselect-to-retry');
    });
  },true);
  const observeRoot=document.querySelector('main');
  if(observeRoot)new MutationObserver(records=>{
    if(!pending)return; // Never re-lock a normal submission or ordinary post-cart rendering.
    const s=section();
    if(records.some(r=>s?.contains(r.target)||[...r.addedNodes,...r.removedNodes].some(n=>n.nodeType===1&&(n.matches?.(blockSelector)||n.querySelector?.(blockSelector)))))lockButtons();
  }).observe(observeRoot,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled']});
})();
